import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/Logo_head_white.png'; // Adjust as needed

const colors = {
  mainBlue: "#061941",
  xanthous: "#F2AF29",
  isabelline: "#F4F3EE",
  carrieban: "#3C6E71",
  cafeNoir: "#583E23",
};

function Footer() {
  return (
    <footer
      style={{
        background: colors.mainBlue,
        color: colors.isabelline,
        marginTop: "auto"
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "2.5rem 2vw"
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "2.5rem",
            marginBottom: "2rem"
          }}
        >
          {/* Brand Section */}
          <div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
              <img src={logo} alt="NeuHawk Logo" style={{ height: "30px", width: "auto" }} />
              <span style={{
                fontWeight: 800,
                fontFamily: "Poppins, Segoe UI, Arial, sans-serif",
                marginLeft: "10px",
                fontSize: "1.5rem",
                color: colors.isabelline,
                letterSpacing: "1.5px"
              }}>
                NeuHawk
              </span>
            </div>
            <p style={{
              color: colors.isabelline + "CC",
              lineHeight: "1.5",
              fontFamily: "Nunito, Segoe UI, Arial, sans-serif"
            }}>
              Connecting graduate students with faculty for meaningful mentorship and research opportunities.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              marginBottom: "1rem",
              color: colors.xanthous,
              fontWeight: 700,
              fontFamily: "Poppins, Segoe UI, Arial, sans-serif"
            }}>
              Quick Links
            </h4>
            <nav style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Link
                to="/student-dashboard"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                Dashboard
              </Link>
              <Link
                to="/student-matching"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                Matching
              </Link>
              <Link
                to="/blog"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                Blog
              </Link>
              <Link
                to="/welcome-page"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                About
              </Link>
                            <Link
                to="/MeetTeam"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                Meet the Team
              </Link>
            </nav>
          </div>

          {/* Support */}
          <div>
            <h4 style={{
              marginBottom: "1rem",
              color: colors.xanthous,
              fontWeight: 700,
              fontFamily: "Poppins, Segoe UI, Arial, sans-serif"
            }}>
              Support
            </h4>
            <nav style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Link
                to="/contact"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                Contact Us
              </Link>
              <Link
                to="/privacy"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                style={{
                  color: colors.isabelline + "CC",
                  textDecoration: "none",
                  fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                  fontWeight: 600,
                  transition: "color 0.15s"
                }}
                onMouseOver={e => e.currentTarget.style.color = colors.xanthous}
                onFocus={e => e.currentTarget.style.color = colors.xanthous}
                onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
                onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              >
                Terms of Service
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          style={{
            borderTop: `1px solid ${colors.isabelline}33`,
            paddingTop: "1.25rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem"
          }}
        >
          <p style={{
            color: colors.isabelline + "CC",
            margin: 0,
            fontFamily: "Nunito, Segoe UI, Arial, sans-serif"
          }}>
            © 2025 NeuHawk. All rights reserved.
          </p>
          <div style={{ display: "flex", gap: "1rem" }}>
            <Link
              to="https://www.linkedin.com/company/neuhawk-inc"
              style={{
                color: colors.isabelline + "CC",
                textDecoration: "none",
                fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
                fontWeight: 600,
                transition: "color 0.15s"
              }}
              onMouseOver={e => e.currentTarget.style.color = colors.carrieban}
              onFocus={e => e.currentTarget.style.color = colors.carrieban}
              onMouseOut={e => e.currentTarget.style.color = colors.isabelline + "CC"}
              onBlur={e => e.currentTarget.style.color = colors.isabelline + "CC"}
            >
              LinkedIn
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;